module.exports = __webpack_public_path__ + "static/media/tetrapackDefault.110dcab3.png";